<template>
  <div class="info">
    <lb-table
      v-loading="loading"
      v-horizontal-scroll="'always'"
      :column="columns"
      :data="page.list"
      pagination
      :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      @selection-change="onMultipleSelection"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  props: {
    phone: {
      type: String,
      default: ''
    },
  },
  components: {
    LbTable
  },
  data () {
    return {
      name: 'cdd',
      list: [{}, {}],
      columns: [
        { label: '订单编号', prop: 'orderNo', minWidth: '200' },
        { label: '收货人姓名', prop: 'postName', minWidth: '220' },
        { label: '收货人电话', prop: 'postContact', minWidth: '120' },
        { label: '下单时间', prop: 'orderTime', minWidth: '120' },
        {
          label: '订单价格', prop: 'receivableAmount', minWidth: '120',
          render: (h, scope) => {
            return (
              <div> {Number(scope.row.receivableAmount).toFixed(2)}</div>
            )
          }
        },
        { label: '订单状态', prop: 'statusLabel', minWidth: '120' },
        { label: '订单类型', prop: 'orderTypeLabel', minWidth: '120' },
        {
          label: '操作',
          minWidth: '120',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div style="cursor:pointer" onClick={() => { this.look(scope.row) }}>
                查看
              </div>
            )
          }
        }],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      loading: false
    }
  },
  watch: {
    phone (val, vall) {
      this.phone = val
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    look (row) {
      this.$router.push({
        name: 'orderDetails',
        query: {
          id: row.id,
          orderId: row.orderId,
          orderNo: row.orderNo,
          awaitSubmit: 'saleAfter'
          // status: row.status
        }
      })
    },
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    fetchData () {
      let data = {
        phone: this.phone,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      this.$api.matrixServerGetOrderList(data).then(res => {
        this.page.list = res.data.list
        this.page.totalNum = res.data.totalNum
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>

